export const LOGIN_PATH = '/login'
export const AUTH_ME_PATH = '/auth/me'
export const AUTH_REFRESH_PATH = '/auth/refresh'

// `/auth/login` answers 401 for a wrong password, and `/auth/refresh` answers 401
// when the session is over. Refreshing on either would turn a failed sign-in into
// a pointless round trip and a dead refresh into a loop. `password/change` is not
// exempt: it needs a session, so its 401 gets the ordinary refresh-and-retry.
const SESSION_EXEMPT = /^\/auth\/(login|logout|refresh|password\/(forgot|set))/

export function isSessionExemptPath(path: string): boolean {
  return SESSION_EXEMPT.test(path)
}

export function isCurrentUserRead(path: string, method?: string): boolean {
  return (
    (method ?? 'GET').toUpperCase() === 'GET' &&
    new URL(path, 'http://localhost').pathname.replace(/\/+$/, '') === AUTH_ME_PATH
  )
}
